export default {
  data() {
    return {
      allMissionAddressesLog: [],
    };
  },
  methods: {
    getAllMissionAddressLogFunction: function (missionId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllMissionAddressLogFor115Mission', missionId).then(() => {
        if (this.$store.state.missionAddressLogModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          const temp = this.$store.state.missionAddressLogModule.allMissionAddressLog;
          this.allMissionAddressesLog = temp;
          if (this.tab == 'four') {
            //جزئیات ماموریت 115 سابقه
            this.readyAddressLogData(temp);
          }
          if (this.editTab == 'address') {
            //جزئیات ماموریت 115 سابقه
            this.readyAddressLogData(temp);
          }
          if (this.$route.name == 'doctorMissions') {
            //doctor
            if (this.doctorOrderTab == '7') {
              this.readyAddressLogData(temp);
            }
          }
          if (this.$route.name == 'dashboardFollowUp') {
            //followUp
            if (this.followUpDashboardDetailTab == 'address') {
              this.readyAddressLogData(temp);
            }
          }
          if (this.$route.name == 'missionReport') {
            //mission report
            if (this.missionReportDetailTab == 'address') {
              this.readyAddressLogData(temp);
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionAddressLogModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllMissionAddressLogFunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionAddressLogModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllMissionAddressLogFunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.missionAddressLogModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
